import Marquee from "react-fast-marquee";

const WORDS = ["BUILD", "OPERATE", "AUTOMATE", "GROW", "INTELLIGENCE", "IMPACT"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-10 border-y border-jx-ink/8 bg-white overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-editorial italic text-4xl sm:text-5xl px-8 ${i % 2 === 0 ? "jx-outline-text" : "jx-gradient-text"}`}>
            {w}
          </span>
          <span className="w-2 h-2 rounded-full jx-gradient-bg" />
        </span>
      ))}
    </Marquee>
  </div>
);
